import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(private http: HttpClient) {}

  getAllThemes(langCode: string = '', searchTerm: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/theme`, {
      headers: { lang: langCode },
      params: { searchTerm },
    });
  }

  getThemeById(id: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/theme/${id}`);
  }

  createTheme(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/theme`, data);
  }

  updateTheme(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/theme/${id}`, data);
  }

  removeTheme(id: any): Observable<any> {
    return this.http.delete(`${environment.authUrl}/theme/${id}`);
  }

  getLanguages(): Observable<any> {
    return this.http.get(`${environment.authUrl}/language`);
  }
}
